import { Action } from 'redux';
import { History } from '../entities';

export enum THistory {
  SET_HISTORY = 'SET_HISTORY',
  FETCH_HISTORY = 'FETCH_HISTORY'
}

export interface ISetHistory extends Action {
  type: THistory.SET_HISTORY;
  payload: History[];
}
export const ASetHistory = (payload: History[]): ISetHistory => ({ type: THistory.SET_HISTORY, payload });

export interface IFetchHistory extends Action {
  type: THistory.FETCH_HISTORY;
}
export const AFetchHistory = (): IFetchHistory => ({ type: THistory.FETCH_HISTORY });
